import CategoryPageRenderer from "@/components/CategoryPageRenderer";
export default function ManasikUmrah() {
  return <CategoryPageRenderer pageKey="manasik-umrah" />;
}
